import React from "react";
import { NavLink } from 'react-router-dom'

import * as func from "../../../../utils/functions";
import JournalItem from "../../../journal/front/list/Jitem";
import {BASE_PATH} from "../../../../wpconfig";
import Loading from "../../../etc/loading";

const JournalLite = (parent) => {
    const records = parent.records;
    const foundRecord = parent.foundRecord;
    const isInit = parent.isInit;
    let url = BASE_PATH + "journals/";
    url += func.getParams('ks') ? "?ks=" + func.getParams('ks') : '';
    return (
        <div className="">
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <h3 className="con-title">Journal ({func.getNumberFormat(foundRecord)}건)</h3>
                    <span className="icon icon-size-24 icon-warning-black align-baseline ml-2" />
                </div>
                <div className="d-flex align-items-center">
                    <NavLink to={url} className="btn-list-more ml-5">더보기
                        <span className="icon icon-size-16 icon-more-arrow-blue" />
                    </NavLink>
                </div>
            </div>
            <div className="mt-26">
                <div>
                    {!isInit && <Loading />}
                    {isInit && records.length <= 0 && <div className="search-none"><div className="icon icon-search-none"></div><div className="desc">검색 결과가 없습니다.</div></div>}
                    {records && records.map((record, index) => {
                        return (
                            <JournalItem key={index} record={record}/>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default JournalLite;
